import { useCallback, useEffect, useState } from 'react';
import { fetchTicketUnreadBadgeCount } from '../lib/tickets';
import { useTicketInboxRealtime } from './useTicketInboxRealtime';

/** Unread ticket count for the dock Tickets badge (excludes Spam / Trash). */
export function useTicketUnreadBadge() {
  const [count, setCount] = useState(0);

  const load = useCallback(async () => {
    try {
      setCount(await fetchTicketUnreadBadgeCount());
    } catch {
      setCount(0);
    }
  }, []);

  useEffect(() => {
    void load();
  }, [load]);

  useTicketInboxRealtime({
    enabled: true,
    channelName: 'crm-tickets-unread-badge',
    onChange: () => void load(),
  });

  return count;
}
